type Listener = () => void;

let visible = false;
const listeners = new Set<Listener>();

export function toggleReactQueryDevtools(): void {
  if (process.env.NODE_ENV === 'production') return;
  visible = !visible;
  listeners.forEach((listener) => listener());
}

export function subscribeReactQueryDevtoolsVisibility(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getReactQueryDevtoolsVisibility(): boolean {
  return visible;
}
